import axios from "axios";
import { authEndpoint } from "../../../routes/api_endpoints";

/**Checks if a user is logged in then responds with the users details if the user is logged in
 * @return {Promise<[loggedIn:boolean,userDetails: object]>}
 */
const CheckAuthPromise = () =>
  new Promise((resolve, reject) => {
    axios
      .post(`${authEndpoint}/checkAuth`, {}, { withCredentials: true })
      .then((response) => {
        if (response.data.loggedIn) {
          resolve([true, response.data.user]);
        } else {
          resolve([false]);
        }
      })
      .catch(reject);
  });

export default CheckAuthPromise;
